// client/src/pages/AboutPage.js
import React from 'react';
import { Box, Button, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Seo from '../components/Seo';
import { whatsappLink } from '../components/WhatsAppButton';
import { useStore } from '../context/StoreContext';

const ContactLine = ({ icon: Icon, children }) => (
  <Stack direction="row" spacing={1.5} alignItems="flex-start">
    <Icon fontSize="small" color="primary" sx={{ mt: 0.25 }} />
    <Typography variant="body2" sx={{ whiteSpace: 'pre-line', overflowWrap: 'anywhere' }}>{children}</Typography>
  </Stack>
);

const AboutPage = () => {
  const { store } = useStore();
  const hasContact = store.support_email || store.phone || store.address || store.trading_hours || store.whatsapp_number;

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 3, md: 6 } }}>
      <Seo title="About & Contact" description={`About ${store.name}, and how to get in touch.`} canonicalPath="/about" />
      <Typography variant="overline" color="primary" sx={{ display: 'block' }}>About &amp; contact</Typography>
      <Typography component="h1" sx={{ fontSize: { xs: '2rem', md: '3rem' }, fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 1.1, mb: 3 }}>
        {store.name}
      </Typography>
      <Box sx={{ display: 'grid', gap: 4, alignItems: 'start', gridTemplateColumns: { xs: '1fr', md: store.about_text ? '2fr 1fr' : '1fr' } }}>
        {store.about_text && (
          <Typography sx={{ whiteSpace: 'pre-line', lineHeight: 1.8, maxWidth: 720 }}>{store.about_text}</Typography>
        )}
        {hasContact ? (
          <Card sx={{ maxWidth: store.about_text ? 'none' : 480 }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2 }}>Get in touch</Typography>
              <Stack spacing={1.5}>
                {store.support_email && <ContactLine icon={EmailOutlinedIcon}><a href={`mailto:${store.support_email}`} style={{ color: 'inherit' }}>{store.support_email}</a></ContactLine>}
                {store.phone && <ContactLine icon={PhoneOutlinedIcon}><a href={`tel:${store.phone.replace(/\s/g, '')}`} style={{ color: 'inherit' }}>{store.phone}</a></ContactLine>}
                {store.address && <ContactLine icon={LocationOnOutlinedIcon}>{store.address}</ContactLine>}
                {store.trading_hours && <ContactLine icon={AccessTimeOutlinedIcon}>{store.trading_hours}</ContactLine>}
              </Stack>
              {store.whatsapp_number && (
                <Button component="a" href={whatsappLink(store.whatsapp_number, store.name)} target="_blank" rel="noopener noreferrer" variant="contained" startIcon={<WhatsAppIcon />} sx={{ mt: 2.5 }}>
                  Chat on WhatsApp
                </Button>
              )}
            </CardContent>
          </Card>
        ) : (
          <Typography color="text.secondary">Contact details are coming soon.</Typography>
        )}
      </Box>
    </Container>
  );
};

export default AboutPage;
